export enum NotificationEmailTemplateEnums {
  WelcomeEmail = 'User Invite',
}
